import { render, staticRenderFns } from "./MandateTransactionsUnit.vue?vue&type=template&id=c7c61d56&scoped=true&"
import script from "./MandateTransactionsUnit.vue?vue&type=script&lang=js&"
export * from "./MandateTransactionsUnit.vue?vue&type=script&lang=js&"
import style0 from "./MandateTransactionsUnit.vue?vue&type=style&index=0&id=c7c61d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c61d56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7c61d56')) {
      api.createRecord('c7c61d56', component.options)
    } else {
      api.reload('c7c61d56', component.options)
    }
    module.hot.accept("./MandateTransactionsUnit.vue?vue&type=template&id=c7c61d56&scoped=true&", function () {
      api.rerender('c7c61d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandateTransactionsUnit.vue"
export default component.exports